import React, { Component } from 'react'

class FilterControls extends Component {
  applySelection = (id) => {
    this.props.onApplySelection(id)
  }

  resetSelection = (id) => {
    this.props.onResetSelection(id)
  }

  render () {
    var resetUiEvent = ''
    if(this.props.applyButtonId.includes('Top')){
      resetUiEvent ='results_removefilterstop'
    }
    else{
      resetUiEvent ='results_removefiltersbottom'
    }

    return (
      <div className='inner-container filterControls box-header'>
        <div>Filter Results</div>
        <div className='filterButtons'>
          <button id={this.props.resetButtonId} name={this.props.resetButtonId} className='pure-button secondary-action' 
            onClick={event => this.resetSelection(this.props.resetButtonId)}
            data-gm-u-pn="content"  
            data-gm-u-c="search"
            data-gm-u-e={resetUiEvent}
            data-gm-u-v='Reset All'
            data-gm-u-a="click">Reset All</button>
          <button id={this.props.applyButtonId} name={this.props.applyButtonId} className='pure-button primary-action' onClick={event => this.applySelection(this.props.applyButtonId)}>Apply</button>
        </div>
      </div>
    )
  }
}
export default FilterControls
